import { equals, isNil } from "ramda";

import { DataFields } from "@enums";
import { UserDataInterface } from "@types";

export const isStateKeyEmpty = (key: string, userData: UserDataInterface) => {
    switch (key) {
        // String data types
        case DataFields.housingType:
        case DataFields.propertyNumber:
        case DataFields.propertyLetterBox:
        case DataFields.propertyPostalCode:
        case DataFields.propertyCity:
        case DataFields.propertyRisk:
        case DataFields.chosenTheftOption:
        case DataFields.yourInformationFirstName:
        case DataFields.yourInformationLastName:
        case DataFields.yourInformationEmail:
        case DataFields.yourInformationPhone:
        case DataFields.yourInformationQuestion:
            return isNil(userData[key]) || equals(userData[key], "");
        // Number data types
        case DataFields.totalPrice:
        case DataFields.totalRoomCount:
            return isNil(userData[key]) || equals(userData[key], 0);
        // Object data types
        case DataFields.insurance:
        case DataFields.propertyStreet:
            return isNil(userData[key]);
        // Boolean data types
        case DataFields.isTheftChecked:
        case DataFields.isLegalChecked:
        case DataFields.isPackageChecked:
        case DataFields.yourInformationConsent:
        case DataFields.flowFinished:
            return isNil(userData[key]) || equals(userData[key], false);
        default:
            return true;
    }
};
